import { FlexView, COLORS } from '@cuemath/comps';
import { Text } from '@cuemath/web-comps';
import styled, { css } from 'styled-components';

export const SCRoot = styled(FlexView)`
  gap: 16px;
  padding: 8px 0px;
`;

export const InfoWrapper = styled(FlexView)`
  width: 320px;
  gap: ${({ gap }) => gap || '16'}px;

  ${({ border }) =>
    border &&
    css`
      padding: 16px 12px;
      border-radius: 8px;
      border: 1px solid ${COLORS.GRAY_XLIGHT};
    `};
`;

export const NameCardWrapper = styled(FlexView)`
  gap: 16px;
  margin-top: ${({ marginTop }) => marginTop};
`;

export const NameCard = styled(Text)`
  min-width: 152px;
  letter-spacing: 1px;
  width: auto;
`;

export const LinkText = styled(Text)`
  width: fit-content;
  border-bottom: 1px solid ${COLORS.COLA};
  line-height: 20px;
  text-align: center;
  cursor: pointer;
  transition: all 0.2s ease-in-out;

  :hover {
    border-bottom: 1px solid ${COLORS.WHITE};
  }
`;
